<!-- start location-selector -->

<div class="location-selector-container">
  <div class="row">
    <div class="col">
      <div (click)="openLocationSelector()" class="btn btn-primary btn-open-modal">Select Location</div>
    </div>
  </div>
</div>


<ng-template #selector>

  <div class="location-selector-modal">
    <div class="modal-header p-3 border-bottom">
      <h2 class="mb-0">Select Location</h2>
      <button type="button" class="close text-primary" aria-label="Close" (click)="cancelSelectLocation()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-body p-0 m-0">
      <div class="map-canvas-container">
        <form id="coordinate-event-transport" (setSelectedCoordinate)="handleCoordinateChange($event)"></form>
        <input type="hidden" id="lat" name="lat" [value]="selectedCoordinate.lat" />
        <input type="hidden" id="long" name="long" [value]="selectedCoordinate.long" />
        <div id="map-canvas" style="width: 800px; height: 500px;"></div>
      </div>
    </div>

    <div class="modal-footer">
      <div class="mt-2">
        <div mat-button class="btn btn-outline-danger" (click)="cancelSelectLocation()">Cancel</div>
        <div mat-button class="btn btn-primary" (click)="selectLocation()">Select</div>
      </div>
    </div>
  </div>

</ng-template>

<!-- end location-selector -->